import { render, staticRenderFns } from "./u-tab.vue?vue&type=template&id=34a587f7&"
import script from "./u-tab.vue?vue&type=script&lang=js&"
export * from "./u-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports